import { z } from 'zod';

/** / — `tour=1` after the Brand Brain is first saved opens the one-time product tour (PROTO showHome(..., {tour})). */
export const homeSearchSchema = z.object({
  tour: z.literal(1).optional().catch(undefined),
});
